var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.2 59.2",
    style: {
      enableBackground: "new 0 0 59.2 59.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A21B2C;}\n\t.st1{fill:none;stroke:#75232E;stroke-width:4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 28.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -21.8602 24.6915)",
    className: "st0",
    width: 4,
    height: 21.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3,
    y: 31.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -13.3554 35.2843)",
    className: "st0",
    width: 35.1,
    height: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.6,
    cy: 29.6,
    r: 27.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.9e5381c3.svg";
export { ForwardRef as ReactComponent };